import { render, staticRenderFns } from "./Wells.vue?vue&type=template&id=203b2ca9"
import script from "./Wells.vue?vue&type=script&lang=ts"
export * from "./Wells.vue?vue&type=script&lang=ts"
import style0 from "./Wells.vue?vue&type=style&index=0&id=203b2ca9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports